export const technologiesConst = [
   {
      id: 't-frontends',
      name: 'Front-End',
      items: [
         {
            name: 'Vue JS',
            image: '/assets/svg/technologies/vuejs.svg',
            alt: 'Vue.js',
         },
         {
            name: 'React JS',
            image: '/assets/svg/technologies/Vector.svg',
            alt: 'React.js',
         },
         {
            name: 'Angular JS',
            image: '/assets/svg/technologies/angular.svg',
            alt: 'Angular',
         },
         {
            name: 'HTML5',
            image: '/assets/svg/technologies/html.svg',
            alt: 'HTML5',
         },
         {
            name: 'CSS3',
            image: '/assets/svg/technologies/css.svg',
            alt: 'CSS3',
         },
         {
            name: 'Next JS',
            image: '/assets/svg/technologies/next.svg',
            alt: 'Next.js',
         },
         {
            name: 'Bootstrap',
            image: '/assets/svg/technologies/bootstrap.svg',
            alt: 'Bootstrap',
         },
         {
            name: 'Three JS',
            image: '/assets/svg/technologies/threejs.svg',
            alt: 'Three JS',
         },
         {
            name: 'jQuery',
            image: '/assets/svg/technologies/jquery.svg',
            alt: 'jQuery',
         },
         {
            name: 'JavaScript',
            image: '/assets/svg/technologies/js.svg',
            alt: 'JavaScript',
         },
         {
            name: 'TypeScript',
            image: '/assets/svg/technologies/ts.svg',
            alt: 'TypeScript',
         },
      ],
   },
   {
      id: 't-backends',
      name: 'Back-End',
      items: [
         { name: 'PHP', image: '/assets/svg/technologies/php.svg', alt: 'PHP' },
         {
            name: 'Django',
            image: '/assets/svg/technologies/dj.svg',
            alt: 'Django',
         },
         {
            name: 'Python',
            image: '/assets/svg/technologies/python.svg',
            alt: 'Python',
         },
         {
            name: 'Laravel',
            image: '/assets/svg/technologies/laravel.svg',
            alt: 'Laravel',
         },
         {
            name: 'Node JS',
            image: '/assets/svg/technologies/node.svg',
            alt: 'Node.js',
         },
         {
            name: 'ASP.NET',
            image: '/assets/svg/technologies/asp.svg',
            alt: 'ASP.NET',
         },
         {
            name: 'JAVA',
            image: '/assets/svg/technologies/java.svg',
            alt: 'Java',
         },
         { name: 'C++', image: '/assets/svg/technologies/c++.svg', alt: 'C++' },
         {
            name: 'CodeIgniter',
            image: '/assets/svg/technologies/codein.svg',
            alt: 'CodeIgniter',
         },
      ],
   },
   {
      id: 't-mobile',
      name: 'Mobile',
      items: [
         { name: 'IOS', image: '/assets/svg/technologies/ios.svg', alt: 'iOS' },
         {
            name: 'Android',
            image: '/assets/svg/technologies/android.svg',
            alt: 'Android',
         },
         {
            name: 'Flutter',
            image: '/assets/svg/technologies/flutter.svg',
            alt: 'Flutter',
         },
         {
            name: 'React Native',
            image: '/assets/svg/technologies/Vector.svg',
            alt: 'React Native',
         },
         {
            name: 'Ionic',
            image: '/assets/svg/technologies/ionic.svg',
            alt: 'Ionic',
         },
         {
            name: 'Swift',
            image: '/assets/svg/technologies/swift.svg',
            alt: 'Swift',
         },
         {
            name: 'Kotlin',
            image: '/assets/svg/technologies/kotlin.svg',
            alt: 'Kotlin',
         },
         {
            name: 'Objective C',
            image: '/assets/svg/technologies/objective.svg',
            alt: 'Objective C',
         },
         {
            name: 'Titanium',
            image: '/assets/svg/technologies/titanium.svg',
            alt: 'Titanium',
         },
      ],
   },
   {
      id: 't-uiux',
      name: 'UI/UX Design',
      items: [
         {
            name: 'Figma',
            image: '/assets/svg/technologies/figma.svg',
            alt: 'Figma',
         },
         {
            name: 'Adobe XD',
            image: '/assets/svg/technologies/xd.svg',
            alt: 'Adobe XD',
         },
         {
            name: 'Sketch',
            image: '/assets/svg/technologies/sketch.svg',
            alt: 'Sketch',
         },
         {
            name: 'Adobe XD',
            image: '/assets/svg/technologies/Adobe.svg',
            alt: 'Adobe XD',
         },
         {
            name: 'Adobe Illustrator',
            image: '/assets/svg/technologies/adobe_illustrator.svg',
            alt: 'Adobe Illustrator',
         },
      ],
   },
   {
      id: 't-cms',
      name: 'CMS',
      items: [
         {
            name: 'Magento',
            image: '/assets/svg/technologies/Magento.svg',
            alt: 'Magento',
         },
         {
            name: 'WordPress',
            image: '/assets/svg/technologies/WordPress.svg',
            alt: 'WordPress',
         },
         {
            name: 'Shopify',
            image: '/assets/svg/technologies/shopify.svg',
            alt: 'Shopify',
         },
         {
            name: 'Webflow',
            image: '/assets/svg/technologies/Webflow.svg',
            alt: 'Webflow',
         },
         {
            name: 'Hubspot',
            image: '/assets/svg/technologies/hubspot.svg',
            alt: 'Hubspot',
         },
         {
            name: 'Craft CMS',
            image: '/assets/svg/technologies/Craft-CMS.svg',
            alt: 'Craft CMS',
         },
         {
            name: 'Joomla',
            image: '/assets/svg/technologies/joomla.svg',
            alt: 'Joomla',
         },
         {
            name: 'Drupal',
            image: '/assets/svg/technologies/Drupal.svg',
            alt: 'Drupal',
         },
         { name: 'Wix', image: '/assets/svg/technologies/wix.svg', alt: 'Wix' },
      ],
   },
   {
      id: 't-database',
      name: 'Database',
      items: [
         {
            name: 'MongoDB',
            image: '/assets/svg/technologies/mongo.svg',
            alt: 'MongoDB',
         },
         {
            name: 'My SQL',
            image: '/assets/svg/technologies/mysql.svg',
            alt: 'MySQL',
         },
         {
            name: 'Firebase',
            image: '/assets/svg/technologies/firebas.svg',
            alt: 'Firebase',
         },
         {
            name: 'SQLite',
            image: '/assets/svg/technologies/SQLite.svg',
            alt: 'SQLite',
         },
         {
            name: 'Realm',
            image: '/assets/svg/technologies/Realm.svg',
            alt: 'Realm',
         },
         {
            name: 'PostgreSQL',
            image: '/assets/svg/technologies/PostgreSQL.svg',
            alt: 'PostgreSQL',
         },
         {
            name: 'Redis',
            image: '/assets/svg/technologies/Redis.svg',
            alt: 'Redis',
         },
         {
            name: 'MsSQL',
            image: '/assets/svg/technologies/MSSQL.svg',
            alt: 'MsSQL',
         },
         {
            name: 'Hive',
            image: '/assets/svg/technologies/Hive.svg',
            alt: 'Hive',
         },
         {
            name: 'Isar',
            image: '/assets/svg/technologies/Isar.svg',
            alt: 'Isar',
         },
      ],
   },
   {
      id: 't-devops',
      name: 'Infra and DevOps',
      items: [
         { name: 'AWS', image: '/assets/svg/technologies/aws.svg', alt: 'AWS' },
         {
            name: 'Google Cloud',
            image: '/assets/svg/technologies/Google-Cloud.svg',
            alt: 'Google Cloud',
         },
         {
            name: 'Gradle',
            image: '/assets/svg/technologies/Gradle.svg',
            alt: 'Gradle',
         },
         {
            name: 'Jenkins',
            image: '/assets/svg/technologies/Jenkins.svg',
            alt: 'Jenkins',
         },
         {
            name: 'Appium',
            image: '/assets/svg/technologies/Appium.svg',
            alt: 'Appium',
         },
         {
            name: 'Selenium',
            image: '/assets/svg/technologies/Selenium.svg',
            alt: 'Selenium',
         },
         {
            name: 'Docker',
            image: '/assets/svg/technologies/Docker.svg',
            alt: 'Docker',
         },
         {
            name: 'Vercel',
            image: '/assets/svg/technologies/Vercel.svg',
            alt: 'Vercel',
         },
         {
            name: 'Azure',
            image: '/assets/svg/technologies/Azure.svg',
            alt: 'Azure',
         },
         {
            name: 'Digital Ocean',
            image: '/assets/svg/technologies/Digital_Ocean.svg',
            alt: 'Digital Ocean',
         },
      ],
   },
   {
      id: 't-management',
      name: 'Project & Management',
      items: [
         {
            name: 'Microsoft Team',
            image: '/assets/svg/technologies/microsoft-teams.svg',
            alt: 'Microsoft Team',
         },
         {
            name: 'Jira',
            image: '/assets/svg/technologies/Jira.svg',
            alt: 'Jira',
         },
         {
            name: 'Asana',
            image: '/assets/svg/technologies/Asana.svg',
            alt: 'Asana',
         },
         {
            name: 'Slack',
            image: '/assets/svg/technologies/Slack.svg',
            alt: 'Slack',
         },
         {
            name: 'ClickUp',
            image: '/assets/svg/technologies/ClickUp.svg',
            alt: 'ClickUp',
         },
         {
            name: 'Trello',
            image: '/assets/svg/technologies/Trello.svg',
            alt: 'Trello',
         },
         {
            name: 'Monday.com',
            image: '/assets/svg/technologies/Monday.com.svg',
            alt: 'Monday.com',
         },
         {
            name: 'Github',
            image: '/assets/svg/technologies/Github.svg',
            alt: 'Github',
         },
         {
            name: 'Gitlab',
            image: '/assets/svg/technologies/Gitlab.svg',
            alt: 'Gitlab',
         },
         {
            name: 'Bitbucket',
            image: '/assets/svg/technologies/Bitbucket.svg',
            alt: 'Bitbucket',
         },
      ],
   },
]
